// @ts-nocheck
import { get, post, put, deleteRequest } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} Viagem
 * @property {number} Id - ID único da viagem
 * @property {string} CodigoIntegracao - Código de integração
 * @property {number} IdUfDestino - ID do estado de destino
 * @property {number} IdUfOrigem - ID do estado de origem
 * @property {number} IdCidadeDestino - ID da cidade de destino
 * @property {number} IdCidadeOrigem - ID da cidade de origem
 * @property {string} NumeroCarga - Número da carga
 * @property {number} IdCarga - ID da carga
 * @property {string} NumeroPlaca - Número da placa do veículo
 * @property {string} NumeroFrota - Número da frota
 * @property {number} IdVeiculo - ID do veículo
 * @property {string} DataInicio - Data de início da viagem
 * @property {string} DataFim - Data de fim da viagem
 * @property {string} NomeMotorista - Nome do motorista
 * @property {number} IdMotorista - ID do motorista
 * @property {number} TotalKmRodado - Total de quilômetros rodados
 * @property {number} ValorFreteLiquido - Valor do frete líquido
 * @property {number} ValorFreteBruto - Valor do frete bruto
 * @property {string} NotasFiscais - Notas fiscais associadas
 * @property {number} UsuarioCriacao - ID do usuário que criou
 * @property {string} DataCriacao - Data de criação
 */
/**
 * @typedef {Object} ViagemCreatePayload
 * @property {string} CodigoIntegracao - Código de integração
 * @property {number} IdUfDestino - ID do estado de destino
 * @property {number} IdUfOrigem - ID do estado de origem
 * @property {number} IdCidadeDestino - ID da cidade de destino
 * @property {number} IdCidadeOrigem - ID da cidade de origem
 * @property {string} NumeroCarga - Número da carga
 * @property {number} IdCarga - ID da carga
 * @property {string} NumeroPlaca - Número da placa do veículo
 * @property {string} NumeroFrota - Número da frota
 * @property {number} IdVeiculo - ID do veículo
 * @property {string} DataInicio - Data de início da viagem
 * @property {string} DataFim - Data de fim da viagem
 * @property {string} NomeMotorista - Nome do motorista
 * @property {number} IdMotorista - ID do motorista
 * @property {number} TotalKmRodado - Total de quilômetros rodados
 * @property {number} ValorFreteLiquido - Valor do frete líquido
 * @property {number} ValorFreteBruto - Valor do frete bruto
 * @property {string} NotasFiscais - Notas fiscais associadas
 */
/**
 * @typedef {Object} ViagemFilters
 * @property {string} [NomeMotorista] - Filtro por nome do motorista
 * @property {string} [NumeroPlaca] - Filtro por placa
 * @property {string} [NumeroFrota] - Filtro por número da frota
 * @property {string} [NumeroCarga] - Filtro por número da carga
 * @property {string} [CidadeOrigem] - Filtro por cidade de origem
 * @property {string} [CidadeDestino] - Filtro por cidade de destino
 * @property {string} [DataInicio] - Filtro por data de início (a partir de)
 * @property {string} [DataFim] - Filtro por data de fim (até)
 * @property {number} [IdMotorista] - Filtro por ID do motorista
 * @property {number} [IdVeiculo] - Filtro por ID do veículo
 * @property {number} [IdCarga] - Filtro por ID da carga
 * @property {number} [pagina] - Número da página (padrão: 1)
 * @property {number} [quantidadePorPagina] - Quantidade de registros por página (padrão: 10)
 */
/**
 * Busca viagens com filtros e paginação
 * @param {ViagemFilters} filters - Filtros de busca
 * @returns {Promise<{totalRegistros: number, paginaAtual: number, quantidadePorPagina: number, registros: Viagem[]}>}
 */
export const getViagens = async (filters = {}) => {
    try {
        const queryParams = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
                queryParams.append(key, filters[key]);
            }
        });
        const response = await get(`${API_URL}/viagens?${queryParams.toString()}`);
        return response;
    }
    catch (error) {
        console.error('Erro ao buscar viagens:', error);
        throw error;
    }
};
/**
 * Busca uma viagem por ID
 * @param {number} id - ID da viagem
 * @returns {Promise<Viagem>}
 */
export const getViagemById = async (id) => {
    try {
        const response = await get(`${API_URL}/viagens/${id}`);
        return response;
    }
    catch (error) {
        console.error(`Erro ao buscar viagem ${id}:`, error);
        throw error;
    }
};
/**
 * Cria uma nova viagem
 * @param {ViagemCreatePayload} data - Dados da viagem
 * @returns {Promise<Viagem>}
 */
export const createViagem = async (data) => {
    try {
        const response = await post(`${API_URL}/viagens`, data);
        return response;
    }
    catch (error) {
        console.error('Erro ao criar viagem:', error);
        throw error;
    }
};
/**
 * Atualiza uma viagem existente
 * @param {number} id - ID da viagem
 * @param {Partial<ViagemCreatePayload>} data - Dados parciais para atualização
 * @returns {Promise<Viagem>}
 */
export const updateViagem = async (id, data) => {
    try {
        const response = await put(`${API_URL}/viagens/${id}`, data);
        return response;
    }
    catch (error) {
        console.error(`Erro ao atualizar viagem ${id}:`, error);
        throw error;
    }
};
/**
 * Exclui uma viagem
 * @param {number} id - ID da viagem
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const deleteViagem = async (id) => {
    try {
        const response = await deleteRequest(`${API_URL}/viagens/${id}`);
        return response;
    }
    catch (error) {
        console.error(`Erro ao excluir viagem ${id}:`, error);
        throw error;
    }
};
